const caLabels = [
  {
    id: 'grs',
    labelKey: 'goal_setting_and_reflection_survey',
    labelDesc: 'Goal-Setting and Reflection Survey'
  },
  {
    id: 'instructorresource',
    labelKey: 'instructor_resource',
    value: 'Instructor Resource'
  },
  {
    id: 'instructionalvideo',
    labelKey: 'instructional_videos_and_video_activity',
    value: 'Instructional Video and Video Activity'
  }
];

export default caLabels;
